import { Component } from 'vue-property-decorator';
import { BaseBlock } from '../../base-block';
import { formatDateLocal } from '@/helpers/dates';
import { Block } from '@/helpers/components';

@Block()
@Component
export class ApartmentSearchInfoBlock extends BaseBlock {
	get currentDateFormated() {
		return formatDateLocal(this.getCurrentDate());
	}
}

export default ApartmentSearchInfoBlock;
